import React from "react";

import {Menu} from "../interfaces";
import formatError from "../utils/formatError";
import styles from "./MenuClosedMessage.scss";

type MenuClosedMessageProps = {
  menu?: Menu;
  isNotAvailable: boolean;
  isHidden?: boolean;
  hiddenMessage?: string;
  isError?: boolean;
  error?: any;
};

export default function MenuClosedMessage({
  menu,
  isHidden,
  isNotAvailable,
  hiddenMessage,
  isError,
  error,
}: MenuClosedMessageProps): JSX.Element {
  const isClosed = Boolean(menu?.closed);
  const isBlackout = Boolean(menu?.blackout);
  let closedMessage = isError ? formatError(error) : menu?.holiday?.note;
  if (isBlackout || isClosed) {
    closedMessage = `${menu?.company}'s menu is not available for this day`;
    if (menu?.blackout_messages?.length) {
      if (menu.blackout_messages.length === 1) {
        closedMessage = menu.blackout_messages[0];
      } else {
        closedMessage = (
          <ul className={styles.closedMessageList}>
            {menu.blackout_messages.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        );
      }
    }
  }
  const closedTitle = menu?.holiday?.name;
  return (
    <>
      {isHidden && (
        <div className={styles.closedContainer}>
          <div className={styles.closedNote}>{hiddenMessage}</div>
        </div>
      )}
      {isNotAvailable && (
        <div className={styles.closedContainer}>
          {closedTitle && (
            <div className={styles.closedTitle}>{closedTitle}</div>
          )}
          {closedMessage && (
            <div className={styles.closedNote}>{closedMessage}</div>
          )}
        </div>
      )}
    </>
  );
}
